module.exports = __webpack_public_path__ + "static/20-5679c551a3aefb994b3f6f4c1801c661.jpg";